import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import * as _moment from "moment";
import { HttpHeaders } from '@angular/common/http';
import { MomMinutesOfMeetingService } from 'src/app/services/mom-minutes-of-meeting.service';
import { ViewPdfComponent } from '../../view-pdf/view-pdf.component';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-mom-meeting',
  templateUrl: './mom-meeting.component.html',
  styleUrls: ['./mom-meeting.component.scss']
})
export class MomMeetingComponent implements OnInit{
  mode:any
  isSubmit:boolean = false
  @ViewChild('editor') editor:any;
  @ViewChild('errorDialog') errorDialog!: TemplateRef<any>

  description:any = "<p><b>Lorem ipsum</b> dolor sit amet, <s>consectetur adipiscing elit</s>, sed do eiusmod tempor <u>incididunt</u> ut labore et dolore <i>magna aliqua</i>.";
  createMeetingForm!: FormGroup
  userForm!:FormGroup

  agendaMode:string = 'add'
  lotteryList:any = []
  boardList:any = []
  meetingTypeList:any = []
  meetingData:any
  meetingList:any = []
  meetingId:number = 0
  userId:number = 0
  userArr:any = []
  usersList:any = []
  fileList:any = [];
  listOfFiles: File[] = [];
  agendaList:any = []
  agendaId:number = 0
  action:string = 'save'
  agendaDescription:any
  dateTime:any
  endTime:any
  startTime:any
  mediaFileName: string;
  mediaList: {name: string, file: string | ArrayBuffer}[] = [];
  fileLoading: boolean;
  selectedFileB64: string | ArrayBuffer;
  mediaFl: File;
  mediaFileIndex: number;

  constructor(private activatedRoute: ActivatedRoute, private formBuilder: FormBuilder, private router: Router,
    private momMinutesOfMeetingService: MomMinutesOfMeetingService, private dialog: MatDialog,
    private modalCtrl: ModalController
  ){
    this.activatedRoute.params.subscribe((res:any)=>{
      this.mode = res.mode,
      this.meetingId = res.id
      console.log(res.mode)
    })

    this.userId = Number(sessionStorage.getItem('userId'))
    this.userForm = this.formBuilder.group({
        id: new FormControl(''),
        prefix: new FormControl('', Validators.required),
        designation: new FormControl('', Validators.required),
        isOscMember: new FormControl('', Validators.required),
        email: new FormControl('', [Validators.required, Validators.email]),
        firstName: new FormControl('', Validators.required),
        lastName: new FormControl('', Validators.required),
        company: new FormControl(),
        isApprover: new FormControl('', [Validators.required]),
        isAttended: [false],
        isApproved: [false],
        userId : new FormControl(''),
        notes: [''],
        isMailSent: [false]
    })

    this.createMeetingForm = this.formBuilder.group({
      login: [''],
      meetingName: ['', [Validators.required]],
      mode: ['', [Validators.required]],
      board: new FormGroup({
        id: new FormControl('', Validators.required),
        boardName: new FormControl(''),
      }),

      lottery: new FormGroup({
        id: new FormControl('', Validators.required),
        lotteryName: new FormControl(''),
        board: new FormControl({})
      }),

      meetingType: new FormGroup({
        id: new FormControl('', Validators.required),
        meetingType: new FormControl(''),
      }),

      dateTime: ['', [Validators.required]],
      location: ['', [Validators.required]],
      media: [[]],
      status: ['SCHEDULED'],
      meetingAgenda: [''],
      preMeetingActionPoints: [''],
      meetingLink: ["", Validators.required],
      startTime: [""],
      endTime: [""],
      isArchived:false,
      meetingCreatedBy: [''],
      meetingUsers: [''],
      notes: '',
      meetingMinutes:[],
      actionPoint:[]
    })


  }

  ngOnInit(): void {
    
    if(this.mode == 'add'){
      this.getMeetingTypeList()
      this.getBoardList()
      // this.getLotteryList()
      this.getAllUsers()
      // this.getAllMeetings()
    }
    
    this.createMeetingForm.statusChanges.subscribe((status) => {
      // console.log("________________", status == 'VALID')
      // console.log(status, this.userArr)

      if(status == 'VALID'){
        let count = 0
        for (let i = 0; i < this.userArr.length; i++) {
          if ((this.userArr[i].isApprover === true || this.userArr[i].isOscMember === true)) {
            count = count + 1; // Found a user with isApprover set to true
          }
        }

        if(count > 0 && this.createMeetingForm.valid){
          this.disableButton = false
        }else if(count == 0){
          this.disableButton = true
        }
      }
      // for (const controlName in this.createMeetingForm.controls) {
      //   if (this.createMeetingForm.controls.hasOwnProperty(controlName)) {
      //     const control = this.createMeetingForm.get(controlName);
      //     // Do something with the control, e.g., access its value or update it
      //     console.log(controlName, control?.valid);
      //   }
      // }
    })

    if(this.mode === 'logs') {
      this.getmeetinglist()
    }
    if(this.mode === 'edit' || this.mode === 'view') {
      this.getMeetingById(this.meetingId)
    }
    if(this.mode === 'archieve'){
      this.getArchieveMeeting()
    }
  }
  getmeetinglist(){
    this.momMinutesOfMeetingService.getMeetingsByUserId()// apiService.getMethod('getMeetingsByUserId')
    .subscribe((res:any)=>{
      this.meetingList = res
    })
  }

  getArchieveMeeting(){
    this.momMinutesOfMeetingService.getArchieveMeeting() //getMethod('getArchieveMeeting')
    .subscribe((res:any)=>{
      this.meetingList = res
    })
  }

  getLotteryByBoard(id:any){
    this.momMinutesOfMeetingService.getLotteriesByBoard(id) //getMethod(`lotteriesByBoard/${id}`)
    .subscribe((res:any)=>{
      this.lotteryList = res
    })
  }

  get createMeetingFormControls() {
    return this.createMeetingForm.controls;
  }

  // get createMeetingFormBoardControls() {
  //   return this.createMeetingFormControls['board'].controls;
  // }

  getBoardList(){
    this.momMinutesOfMeetingService.getBoards()//getMethod('boards')
    .subscribe((res:any)=>{
      this.boardList = res
    })
  }

  getAllMeetings(){
    this.momMinutesOfMeetingService.getMeetings()//.getMethod('meetings')
    .subscribe((res:any)=>{
      this.meetingList = res
      console.log('meetingList', this.meetingList)
    })
  }

  getMeetingById(id:number){
    this.momMinutesOfMeetingService.getMeetingsById(id)//getMethod(`meetings/${id}`)
    .subscribe((res:any)=>{
      this.meetingData = res
      console.log(res)
      this.createMeetingForm.patchValue(res)
      this.startTime = res.startTime
      this.endTime = res.endTime
      this.dateTime = new Date(res.dateTime).toISOString()
      return res
    })
  }

  dateFormat(d:any){
    this.dateTime = new Date(d).toISOString()
    console.log(this.dateTime)
  }

  getLotteryList(){
    this.momMinutesOfMeetingService.getLotteries()//getMethod('lotteries')
    .subscribe((res:any)=>{
      this.lotteryList = res
    })
  }

  getMeetingTypeList(){
    this.momMinutesOfMeetingService.getMeetingTypes()//getMethod('meetingTypes')
    .subscribe((res:any)=>{
      this.meetingTypeList = res
    })
  }

  getAllUsers(){
    //TODO
    // this.apiService.getMethod('users')
    // .subscribe((res:any)=>{
    //   this.usersList = res
    // })
  }

  verifyUser(email:string){
    let isValid:boolean
    return this.momMinutesOfMeetingService.getMomUserByEmail(email) //getMethod(`users/${email}`)
    .subscribe((res:any)=>{
      if(res.id){
       isValid = true
      }else{
        isValid = false
        alert('This user is not exist in system. Please contact System Admin')
      }
      return isValid
    })
  }

  errorMsg:string = '';
  disableButton:boolean = true
  addUserDetails(){
    console.log(this.userForm.value.isOscMember == false, this.userForm.value.isApprover == false, this.userForm.value)
    if(this.userForm.value.isOscMember == false && this.userForm.value.isApprover == false){
      this.userArr.push(this.userForm.value)
      this.userForm.reset()
    }else{
      this.momMinutesOfMeetingService.getMomUserByEmail(this.userForm.value.email)//getMethod(`users/${this.userForm.value.email}`)
      .subscribe((res:any)=>{
        if(res && res.id){
          if(this.userForm.value.isOscMember){
           if(this.userForm.value.isOscMember && res.authorities.includes('OSC')){
            this.userForm.value.userId = res.id
            this.userForm.value.login = this.userForm.value.email
            this.userArr.push(this.userForm.value)
            this.createMeetingForm.value.meetingUsers = this.userArr            
            this.userForm.reset()
            if(this.createMeetingForm.valid){
              this.disableButton = false
            }
           }else{
            this.errorMsg = 'Not an OSC Member'
            this.dialog.open(this.errorDialog, {
              width: '40%',
              // height: '15%'
            })
           }
          }else if(this.userForm.value.isApprover){
            if(this.userForm.value.isApprover && res.authorities.includes('MOM_APPROVER')){
              this.userForm.value.userId = res.id
              this.userForm.value.login = this.userForm.value.email
              this.userArr.push(this.userForm.value)
              if(this.createMeetingForm.valid){
                this.disableButton = false
              }
              this.userForm.reset()
            }else{
              this.errorMsg = 'Not an Approver'
              this.dialog.open(this.errorDialog, {
                width: '40%',
                // height: '15%'
              })
            }

          }
          this.userForm.value.id = res.id
          this.createMeetingForm.value.meetingUsers = this.userArr
          // console.log(this.createMeetingForm.value)
        }
      }, (error)=>{
        this.errorMsg = error.message||error?.error?.errorMessage//'This user does not exist in system. Please contact System Admin'
        this.dialog.open(this.errorDialog, {
          width: '40%',
          // height: '15%'
        })
      })
    }
  }

  removeMember(index:number){
    this.userArr.splice(index, 1)
    let count = 0
    for (let i = 0; i < this.userArr.length; i++) {
      if ((this.userArr[i].isApprover === true || this.userArr[i].isOscMember === true)) {
        count = count + 1; // Found a user with isApprover set to true
      }
    }
    console.log(this.userArr,count)
    if(count > 0 && this.createMeetingForm.valid){
      this.disableButton = false
    }else if(count == 0){
      this.disableButton = true
    }
  }

  approverStatus(event:any){
    this.userForm.value.isApprover = event.target.value
  }

  memberStatus(event:any){
    this.userForm.value.isOscMember = event.target.value
  }

  saveMeeting(){
    this.createMeetingForm.value.dateTime = new Date(this.dateTime).toISOString()
    this.createMeetingForm.value.meetingUsers = this.userArr.map(u => {return {
      ...u,
      istApproved: u.isApproved,
      istApprover: u.isApprover,
      istAttended: u.isAttended,
      istMailSent: u.isMailSent,
      istOscMember: u.isOscMember
    }})
    this.createMeetingForm.value.status = 'SCHEDULED'
    this.createMeetingForm.value.lottery.board = this.createMeetingForm.value.board
    this.createMeetingForm.value.meetingAgenda = this.agendaList
    this.createMeetingForm.value.meetingCreatedBy = sessionStorage.getItem('userId')
    // console.log("this.createMeetingFormControls", this.createMeetingForm.value)


    this.momMinutesOfMeetingService.saveMeeting({
      ...this.createMeetingForm.value,
      attachments: this.mediaList, 
      board: +this.createMeetingForm.value.board?.id,
      lottery: +this.createMeetingForm.value.lottery?.id,
      meetingAgenda: this.agendaList?.map(a => a.name),
      meetingType: +this.createMeetingForm.value?.meetingType.id      
    }) //postMethod('meetings', this.createMeetingForm.value)
    .subscribe((res:any)=>{
      console.log("Meeting Added", res)
      if(res.id){
        this.createMeetingForm.reset();
        this.userForm.reset();
        this.userArr = []
        this.agendaList = [];
        this.router.navigate(['/secure/mom-meeting/meeting-logs/logs'])
        this.momMinutesOfMeetingService.successToast("Meeting created successfully.")
      }
    })
  }


  nameInitials(firstName:string, lastName:string){
   let initials = firstName[0].substring(0, 1).toUpperCase() + " " + lastName[0].substring(0, 1).toUpperCase();
   return initials
  }

  fileData = new FormData
  onFileChanged(event: any) {
    for (var i = 0; i <= event.target.files.length - 1; i++) {
      var selectedFile = event.target.files[i];
      if (this.listOfFiles.indexOf(selectedFile.name) === -1) {
        this.fileList.push(selectedFile);
        this.listOfFiles.push(selectedFile.name);
      }
    }
  }

  uploadFiles () {
    this.fileData = new FormData();
    if(this.fileList.length > 0){
      for(let i = 0; i < this.fileList.length; i++){
        this.fileData.append('files', this.fileList[i])
      }
    }
    this.fileData.append('status', 'hey');
    this.momMinutesOfMeetingService.mediaFileUpload(this.fileData) //fileUpload('media', this.fileData)
    .subscribe((res:any)=>{
      this.createMeetingForm.patchValue({
        media: res
      })
      console.log(this.createMeetingForm.value.media)

    })
  }

  removeSelectedFile(index:number) {
    this.listOfFiles.splice(index, 1);
    this.fileList.splice(index, 1);
  }


  removeSelectedAgenda(index:number) {
    this.agendaList.splice(index, 1);
  }

  removeSelectedMedia(index:number) {
    this.mediaList.splice(index, 1);
  }

  editAgenda(index:number, mode:string){
    console.log(this.agendaList[index])
    this.agendaMode = mode
    this.agendaId = index
    this.createMeetingForm.patchValue({
      meetingAgenda: this.agendaList[index].name
    })
  }

  editMedia(index: number, temlateRef:TemplateRef<any>) {
    let media = this.mediaList[index];
    this.mediaFileIndex = index;
    this.mediaFileName = media.name;
    this.mediaFl = null;
    this.dialog.open(temlateRef, {
      width: "30%",
      
    });
  }

  async viewMedia(index: number) {
    console.log(this.mediaList[index].file);
    const modal = await this.modalCtrl.create({
      component: ViewPdfComponent,
      componentProps: {
        base64: this.mediaList[index].file.toString().replace('data:application/pdf;base64,', ''),
        documentName: "Attachment",
        fileName: this.mediaList[index].name
      }
    });
    modal.present();
  }

  addAgenda(){
    // let listLength = this.agendaList.length
    if(this.createMeetingForm.value.meetingAgenda){
      if(this.agendaMode == 'add'){
        this.agendaList.push({name:this.createMeetingForm.value.meetingAgenda, description: ''})
        this.createMeetingForm.patchValue({
          meetingAgenda: ''
        })
      }else if(this.agendaMode == 'edit'){
        this.agendaList[this.agendaId].name =  this.createMeetingForm.value.meetingAgenda
        this.createMeetingForm.patchValue({
          meetingAgenda: ''
        })
      }
      this.agendaMode = 'add'
    }else{
      alert("Enter Meeting Agenda First")
    }
  }

  addMedia(temlateRef:TemplateRef<any>) {
    this.fileLoading = false;
    this.selectedFileB64 = null;
    this.mediaFileName = null;
    this.mediaFl = null;
    this.mediaFileIndex = null;
    this.dialog.open(temlateRef, {
      width: "30%",
      
    });
  }

  uploadMediaFile() {
    this.mediaList.push({
      name: this.mediaFileName,
      file: this.selectedFileB64
    });
    this.dialog.closeAll();
  }

  updateMediaFile() {
    let media = this.mediaList[this.mediaFileIndex];
    media.name = this.mediaFileName;
    media.file = this.selectedFileB64;
    this.dialog.closeAll();
  }

  openConfirmationModal(temlateRef:TemplateRef<any>, meetingId:number){
    this.meetingId = meetingId
    this.dialog.open(temlateRef, {
      width: "30%",
      // height: "15%"
    })
  }

  meeting:any
  time:any
  openModal(temlateRef:TemplateRef<any>, meetingId:number){
    this.momMinutesOfMeetingService.getMeetingsById(meetingId)//getMethod(`meetings/${meetingId}`)
    .subscribe((res:any)=>{
      this.meeting = res
      this.time = new Date(res.dateTime).toISOString()
      console.log(this.time)
    })
    this.dialog.open(temlateRef, {
      minWidth: "70%",
      minHeight: "90vh"
    })
  }

  goToEditMeeting(){
    this.dialog.closeAll()
    this.router.navigate(['/secure/mom-meeting/edit-meeting/edit', {mode:'edit', id: this.meetingId}])
  }

  goToViewMeeting(){
    this.dialog.closeAll()
    this.router.navigate(['/secure/mom-meeting/view', {mode:'view', id: this.meetingId}])
  }

  goToMeetingLogs(){
    this.dialog.closeAll()
    this.router.navigate(['/secure/mom-meeting/meeting-logs', 'logs'])
  }

  archieveMeeting(){
    this.dialog.closeAll()
    let meeting:any = this.momMinutesOfMeetingService.getMeetingsById(this.meetingId)
    //getMethod(`meetings/${this.meetingId}`)
    .subscribe((res:any)=>{
      if(res.id){
        res.isArchived = true
        this.momMinutesOfMeetingService.updateMeeting(res)
        //.putMethod('meetings', res)
        .subscribe((res:any)=>{
          if(res.id) {
            console.log("Successfull")
            this.getAllMeetings()
          }
        })
      }
    })
  }

  cancelMeeting(){
    this.dialog.closeAll()
    let meeting:any = this.momMinutesOfMeetingService.getMeetingsById(this.meetingId)
    // getMethod(`meetings/${this.meetingId}`)
    .subscribe((res:any)=>{
      if(res.id){
        res.status = "CANCELED"
        this.momMinutesOfMeetingService.updateMeeting(res)
        // putMethod('meetings', res)
        .subscribe((res:any)=>{
          if(res.id) {
            console.log("Successfull")
            this.getmeetinglist()
          }
        })
      }
    })
  }

  setStyle(style: string) {
    let bool = document.execCommand(style, false, '');
  }

  downloadPdf(url:string){
    console.log(url)
    var link = document.createElement('a');
    link.href = url;
    link.download = 'file.pdf';
    link.target = '_blank'
    link.dispatchEvent(new MouseEvent('click'));
  }

  // sendMeetingPdf(options?: {
  //   headers?: HttpHeaders | {
  //     [header: string]: string | string[];
  //   };
  //   observe?: 'body';
  //   params?: {
  //     [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
  //   };
  //   responseType?: 'json';
  //   withCredentials?: boolean;
  // }){
  //   const element = document.getElementById('pdfView');

  //   const formData = new FormData();
  //   let file:any
  //   html2pdf().from(element).outputPdf().then((pdf: any) => {
  //     file =  new Blob([pdf], { type: 'application/pdf' })
  //     formData.append('files', new File([file], 'new file', {type: "application/pdf"}));
  //     console.log( new File([file], 'new file', {type: "application/pdf"}))
  //     console.log(options)
  //     this.http.post(this.url+'/media',formData).subscribe((res:any)=>{
  //       console.log('Response', res)
  //     })
  //   });  
  // }

  sendMeetingPdf(){
    const element = document.getElementById('pdfView')!;    
    console.log(element.toString())
    console.log(element.outerHTML)

    let body:any = {
      "meetingId":20802,
      'htmlContent': element.outerHTML
    }
    this.momMinutesOfMeetingService.htmlToPdf(body)//postMethod('htmlToPDF', body)
    .subscribe((res:any)=>{
      console.log(res)
    })
  }

  agendas:any
  openAgendasDialog(dialog:TemplateRef<any>, id:any){
    this.agendas = ''
    this.agendas = this.meetingList.find((e:any) => e.id == id)
    console.log(this.agendas)
    this.dialog.open(dialog, {
      width: '70%'
    })
  }

  onMediaFileSelect(event) {
    this.fileLoading = true;
    this.mediaFl = event.target.files[0];
	  const reader = new FileReader();
	  reader.readAsDataURL(this.mediaFl);
	  reader.onload = () => {
		  this.selectedFileB64 = reader.result;
      this.fileLoading = false;
	  }
  }
  
  
}
const httpOptionsForPdf = {
  headers: new HttpHeaders({
    'Content-Type': 'multipart/form-data',
    'Authorization': '',
  })
}